import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import ExploreIcon from '@mui/icons-material/Explore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BusinessIcon from '@mui/icons-material/Business';

export default function OpportunityFinder({ opportunities, title = "New Opportunities" }) {
    const navigate = useNavigate();

    if (!opportunities || opportunities.length === 0) {
        return (
            <div className="dashboard_section">
                <div className="section_header">
                    <h3><ExploreIcon /> {title}</h3>
                </div>
                <div className="empty_state small">
                    <p>No new opportunities matching your profile.</p>
                    <button 
                        className="find_projects_btn"
                        onClick={() => navigate('/find-a-project')}
                    >
                        Browse All Projects
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard_section">
            <div className="section_header">
                <h3><ExploreIcon /> {title}</h3>
                <button 
                    className="view_all_link"
                    onClick={() => navigate('/find-a-project')}
                >
                    View All
                </button>
            </div>
            <div className="opportunities_list">
                {opportunities.map((project) => (
                    <div 
                        key={project.id} 
                        className="opportunity_item"
                        onClick={() => navigate(`/project-details/${project.id}`)}
                    >
                        <div className="opportunity_content">
                            <h4 className="opportunity_title">
                                {project.project_name.length > 45 
                                    ? `${project.project_name.slice(0, 45)}...` 
                                    : project.project_name}
                            </h4>
                            <div className="opportunity_meta">
                                {project.user && (
                                    <span className="meta_item">
                                        <BusinessIcon />
                                        {project.user.company_name || `${project.user.fname} ${project.user.lname}`}
                                    </span>
                                )}
                                {project.project_state && (
                                    <span className="meta_item">
                                        <LocationOnIcon />
                                        {project.project_state}
                                    </span>
                                )}
                            </div>
                            <span className="opportunity_date">
                                <CalendarTodayIcon />
                                Posted {moment(project.created_at).fromNow()}
                            </span>
                        </div>
                        <div className="opportunity_action">
                            <span className="new_badge">New</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
